import React from 'react';

import { useLocation } from 'react-router';

import { RenderCardInfo } from './RenderCardInfo';

export const DeleteCard = ({ cardList, handler }) => {
  const location = useLocation();
  const currentCard = cardList.find(({ cardId }) => cardId === location.state);
  return (
    <div className="card-info-wrapper">
      <div className="title-section">Delete card</div>
      <div className="fields-wrapper">
        <div className="card-info-wrapper">
          <RenderCardInfo isSectionDelete cardInfo={currentCard} actionCardHandler={handler} />
        </div>
      </div>
    </div>
  );
};
